<div [style.width]="props.width || '100%'">
  <mat-form-field appearance="outline">
    <input
      matInput
      autocomplete="no-autofill"
      [placeholder]="props?.placeholder"
      [matAutocomplete]="auto"
      [formControl]="control"
      aria-label="Search Bar"
    />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="suggestionSelected($event)">
      <mat-option *ngFor="let suggestion of props?.options">
        <span *ngFor="let sugg of suggestion">
          {{ sugg?.title }}
        </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
